package app.footyguide.web.page

data class RefreshLease(
    val ownerId: String,
    val issuedAtMs: Long,
)

data class RefreshLeaseRequest(
    val ownerId: String,
    val nowMs: Long,
    val leaseMs: Long,
    val graceMs: Long = 15_000L,
    val visible: Boolean = true,
)

fun canAcquireRefreshLease(
    currentLease: RefreshLease?,
    request: RefreshLeaseRequest,
): Boolean {
    if (!request.visible) return false
    if (currentLease == null) return true
    val elapsedMs = request.nowMs - currentLease.issuedAtMs
    if (elapsedMs < 0) return false
    return elapsedMs >= request.leaseMs + request.graceMs
}

fun shouldIgnoreRefreshMessage(
    sourceId: String?,
    ownerId: String,
): Boolean = sourceId.isNullOrBlank() || sourceId == ownerId

fun buildLiveRefreshKey(
    date: String,
    competitionId: String,
): String = "$date:$competitionId"
